import { Effect } from 'effect';

import type { Cart as CartView } from './cartSchema';
import { cartConfirmationFailure } from './errors';
import type { CartWriteError } from './errors';

/** A successful write answers only after the shop confirms its current Cart. */
export const confirmAdapterWrite = <RWrite, ERead, RRead>(
  operation: string,
  writeToken: Effect.Effect<string, CartWriteError, RWrite>,
  read: (token: string) => Effect.Effect<CartView, ERead, RRead>
): Effect.Effect<CartView, CartWriteError, RWrite | RRead> =>
  writeToken.pipe(
    Effect.flatMap((token) =>
      read(token).pipe(Effect.mapError((cause) => cartConfirmationFailure(operation, token, cause)))
    )
  );
